import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-sage/20 last:border-0" data-id="element-182">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-terra rounded-sm" onClick={onClick} aria-expanded={isOpen} data-id="element-183">
        <span className="font-serif text-xl font-medium text-olive pr-4" data-id="element-184">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-terra transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-185" />
      </button>
      <div className="accordion-content" data-state={isOpen ? 'open' : 'closed'} data-id="element-186">
        <div className="pb-6 text-olive/80 leading-relaxed" data-id="element-187">{answer}</div>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: React.ReactNode;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0); // First item open by default
  return <div className="w-full max-w-3xl mx-auto bg-white rounded-2xl shadow-soft p-6 md:p-8" data-id="element-188">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-189" />)}
    </div>;
}